/**
 * Format date into time string: HH:MM
 *
 * @param {Date} date
 * @returns {string}
 * @memberof FormSetHour
 */
export const showTime = (date: Date): string => {
    return showHours(date) + ':' + showMinutes(date);
}

/**
 * Format hours from date into string: HH
 *
 * @param {Date} date
 * @returns {string}
 * @memberof FormSetHour
 */
export const showHours = (date: Date): string => {
    return formatHourNumber(date.getHours());
}
/**
 * Format minutes from date into string: MM
 *
 * @param {Date} date
 * @returns {string}
 * @memberof FormSetHour
 */
export const showMinutes = (date: Date): string => {
    return formatHourNumber(date.getMinutes());
}

/**
 * Add leading zero for number less than 9
 *
 * @param {number} time hours or minutes value
 * @returns {string}
 * @memberof FormSetHour
 */
const formatHourNumber = (time: number): string => {
    if (time < 10) {
        return `0${time.toString()}`;
    } else {
        return time.toString();
    }
}
